// Public reader for the currently active promotion.
// Calls the security-definer RPC `get_active_promotion()` which exposes
// only the single enabled row and only the publicly-safe columns.
import { supabase } from "@/integrations/supabase/client";

export interface ActivePromotion {
  id: string;
  slug: string;
  name: string;
  public_headline: string;
  supporting_text: string;
  discount_percentage: number;
  cta_url: string;
  terms_url: string;
  start_at: string;
  end_at: string;
  last_chance_enabled: boolean;
  last_chance_headline: string;
  last_chance_supporting_text: string;
}

export async function fetchActivePromotion(): Promise<ActivePromotion | null> {
  try {
    const { data, error } = await (
      supabase as unknown as { rpc: (n: string) => Promise<{ data: unknown; error: unknown }> }
    ).rpc("get_active_promotion");
    if (error || !Array.isArray(data) || data.length === 0) return null;
    const row = data[0] as ActivePromotion;
    return row;
  } catch {
    return null;
  }
}
